import React, { SyntheticEvent, useState } from "react"
import Box from "@mui/material/Box"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"

import { formQuestionTabs } from "./FormQuestions"
import { IICPatternTypeForm } from "./IICPatternTypeForm"
import { IICPatternFeaturesForm } from "./IICPatternFeaturesForm"
import { useEventReviewForm } from "../../../../../../../../../Providers/EventReviewProvider"
import { IICPatternType } from "../../../../../Types/EventReview"
import { MobergFontFamily, MobergFontSize } from "../../../../../../../../../Moberg"
import styled from "styled-components"

const COMPLETION_COLORS = {
	complete: "#4CAF50",
	incomplete: "#F44336",
}

const patternTypeHasFeatures = (patternType: IICPatternType | null): boolean =>
	patternType !== null &&
	patternType !== IICPatternType.OTHER

export const EventReviewFormsWindow = ({ incompleteEvents, totalEvents }: {
	incompleteEvents: number
	totalEvents: number
}) => {
	const eventReviewForm = useEventReviewForm()
	const [selectedTab, setSelectedTab] = useState(formQuestionTabs.IIC_PATTERN_TYPE)

	const tabs = patternTypeHasFeatures(eventReviewForm.patternType)
		? [formQuestionTabs.IIC_PATTERN_TYPE, formQuestionTabs.IIC_PATTERN_FEATURES]
		: [formQuestionTabs.IIC_PATTERN_TYPE]

	const activeTab = tabs.includes(selectedTab) ? selectedTab : tabs[0]

	const tabStyles = {
		textTransform: "none",
		fontSize: MobergFontSize.REGULAR,
		fontFamily: MobergFontFamily.REGULAR,
		fontWeight: 600,
		padding: "0px 8px",
		color: "var(--text-secondary-color)",
		"&.Mui-selected": {
			color: "var(--color-accent-interactive)",
		},
	}

	const handleChangeTab = (_: SyntheticEvent, value: any) => {
		setSelectedTab(value)
	}

	return (
		<Box sx={{ overflow: "hidden", height: "100%", display: "flex", flexDirection: "column", gap: "8px" }}>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<Tabs
					value={activeTab}
					onChange={handleChangeTab}
					sx={{
						"& .MuiTabs-indicator": {
							backgroundColor: "var(--color-accent-interactive)",
						},
					}}
				>
					{tabs.map((tab) => <Tab
						key={tab}
						label={tab}
						value={tab}
						sx={{ ...tabStyles }}
						disableRipple
					/>)}
				</Tabs>

			<div style={{ display: 'flex', alignItems: 'center' }}>
				<span
					style={{
						color: incompleteEvents === 0 ? COMPLETION_COLORS.complete : COMPLETION_COLORS.incomplete,
						fontSize: MobergFontSize.REGULAR,
						fontFamily: MobergFontFamily.REGULAR,
						fontWeight: 600,
					}}
				>
					{totalEvents - incompleteEvents}/{totalEvents} Complete
				</span>
			</div>
			</Box>

			<ScrollableFormContent>
				{activeTab === formQuestionTabs.IIC_PATTERN_TYPE && <IICPatternTypeForm />}
				{activeTab === formQuestionTabs.IIC_PATTERN_FEATURES && <IICPatternFeaturesForm />}
			</ScrollableFormContent>
		</Box>
	)
}

const ScrollableFormContent = styled.div`
	height: 100%;
	padding: 0;
	overflow-y: auto;
	scrollbar-width: thin;
  scrollbar-color: var(--color-scrollbar-thumb) transparent;

  &::-webkit-scrollbar {
    display: block;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--color-scrollbar-thumb);
    border-radius: 8px;
  }
`
